import { isRegistrationEnabled } from '../utils/featureFlags';
import { AuthStdFooter } from "../utils/auth-std-footer"
import { AuthoratorTitle } from '../utils/auth-title-name'
import { CallToActionBlurbs } from '../utils/callBlurbsAndIsignup'
import { Link } from "react-router-dom";
import { Icon, Image } from "semantic-ui-react"
import girlAudioBookListener from '../assets/shutterstock_2294369429.png'
import narrator from '../assets/narrator_1-1.png'
import narratorSmall from '../assets/narrator_1-1-480x490.png';
import voiceActorReading from '../assets/woman_recording_from_holo.jpg'; // possible image: woman_recording_from_holo_2.jpg
import bookCreatorVoiceActorDeal from '../assets/bookCreator_VoiceActor_Interacting.jpg';

// import robotReader from '../assets/shutterstock_2294257189.jpg';
import robotReaderLarge from '../assets/shutterstock_2294257189-1024x1024.jpg';
import robotReaderMedium from '../assets/shutterstock_2294257189-980x980.jpg';
import robotReaderSmall from '../assets/shutterstock_2294257189-480x480.jpg';

// import textInjestion from '../assets/shutterstock_2294396055.jpg';
import textIngestionLarge from '../assets/shutterstock_2294396055-1024x1024.jpg';
import textIngestionMedium from '../assets/shutterstock_2294396055-980x980.jpg';
import textIngestionSmall from '../assets/shutterstock_2294396055-480x480.jpg';

// import bookListener from '../assets/shutterstock_2294374881.jpg';
import bookListenerLarge from '../assets/shutterstock_2294374881-1024x1024.jpg';
import bookListenerMedium from '../assets/shutterstock_2294374881-980x980.jpg';
import bookListenerSmall from '../assets/shutterstock_2294374881-480x480.jpg';

import mediaIngestionLarge from '../assets/shutterstock_2294394255-1024x1024.png';
import mediaIngestionMedium from '../assets/shutterstock_2294394255-980x980.png';
import mediaIngestionSmall from '../assets/shutterstock_2294394255-480x480.png';


// import brightTree from '../assets/bright_idea_on_tree.png';
import brightTreeLarge from '../assets/bright_idea_on_tree-1024x1024.png';
import brightTreeMedium from '../assets/bright_idea_on_tree-980x980.png';
import brightTreeSmall from '../assets/bright_idea_on_tree-480x480.png';

// import readerOnStack from '../assets/shutterstock_2294366549.png'
import readerOnStackLarge from '../assets/shutterstock_2294366549-1024x1024.png';
import readerOnStackMedium from '../assets/shutterstock_2294366549-980x980.png';
import readerOnStackSmall from '../assets/shutterstock_2294366549-480x480.png';



import stayTuned from '../assets/shutterstock_2277388567-400x250.jpg'
import weGotIt from '../assets/cybor_at_workstation_1024x640_157349a5-c624-4d52-a1c2-aff1aa2bc52f.png'
import effortIn from '../assets/libraryTornado_b.png'

import '../styles/landingPage.css'


const dummyNews = [
  { articleItemUuid: '49864a6f-6e90-47d4-9771-582bf6897117', itemThumbnail: stayTuned, itemHeading: 'Stay Tuned', itemContent: "Turn the wheel, read the story...pick a narrator...get the glory." },
  { articleItemUuid: '75270fcf-6b29-48e8-ab12-b5b580989179', itemThumbnail: effortIn, itemHeading: 'Possibilities swirl like a storm...', itemContent: "The possibilities are rife! What more needs saying?" },
  { articleItemUuid: '38e40399-010d-4c4d-b2fe-c3287239bf87', itemThumbnail: weGotIt, itemHeading: 'We get to it…', itemContent: "We're working on things...like crazy!" }
]

export default function Landing() {


  const newsItem = (itemData, itemKey) => {
    return (
      <div key={itemKey} className="column size-1of3">
        <article id="post-413" className="et_pb_post clearfix et_pb_article_item_0_2 post-413 post  format-standard has-post-thumbnail ">
          <div className="et_pb_image_container">
            <Link to={`/articleItemContainer/${itemData.articleItemUuid}`} >
              {/* <img decoding="async" src={itemData.itemThumbnail} alt="We get to it…" className="" width="400" height="250" /> */}
              <Image src={itemData.itemThumbnail} />
            </Link>
          </div>
          <h3 className="entry-title">
            <Link to={`/articleItemContainer/${itemData.articleItemUuid}`} >{itemData.itemHeading}</Link>
          </h3>
          {/* <p className="post-meta"></p> */}
          <div className="post-content">
            <div className="post-content-inner"><p>{itemData.itemContent}</p> </div>
          </div>
        </article>
      </div>
    )
  }

  const displayNewsItems = () => {
    return dummyNews.map((x, idx) => {
      return newsItem(x, idx)
    })
  }

  const landingPage = () => {
    return (
      <>
        <div className="std-pg-main-area landing-std-pg-main-area" >
          <div className="landingPgProcessBackground">
            <div id="et-main-area">
              <div id="main-content">
                <article className="">
                  <div className="entry-content">
                    <div className="">
                      <div className="et_builder_inner_content et_pb_gutters3">
                        <div className="et_pb_section et_pb_section_0 et_pb_with_background et_section_regular topMainBkgImage">
                          <div className="et_pb_row et_pb_row_0">
                            <div className="et_pb_column et_pb_column_4_4 et_pb_column_0 ">
                              <div className="et_pb_module et_pb_image et_pb_image_0">
                                <span className="et_pb_image_wrap ">
                                  <img className="landingPgBackgroundImg" src={girlAudioBookListener} alt="Audiobook Reader" title="Happy Listener" />
                                </span>
                              </div>
                            </div>
                          </div>
                          <div className="et_pb_row et_pb_row_1 block_centered">
                            <div className="et_pb_column et_pb_column_4_4">
                              <div className="landingHeroContainer">
                                <div className="">
                                  <div className=""><span className="landingTagLine">Help For Author Narrations</span></div>
                                </div>
                                <div className="noMargNoPad"><AuthoratorTitle /></div>
                              </div>
                              <div style={{ float: "left", paddingLeft: "5%" }}>{CallToActionBlurbs()}</div>
                              {/* This button advertised an option that does not exist, twice over.
                                  It was never gated by isRegistrationEnabled() — unlike the Navbar
                                  and LoginPage CTAs — so it stayed visible on a build where
                                  registration answers 503; and it is a bare div with no Link and no
                                  handler, so clicking it has never done anything at all. Gated now,
                                  which removes it from the deployed build. */}
                              {isRegistrationEnabled() && (
                                <div className="btn-13" style={{ border: "solid 1px #666666", marginTop: "20px", marginLeft: "5%" }}>Sign up</div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="et_pb_section et_pb_section_1 et_pb_with_background et_section_regular">
                          <div className="et_pb_row ">
                            <div className="et_pb_column et_pb_column_4_4">
                              <div className="et_pb_module et_pb_text et_pb_text_5  et_pb_text_align_left et_pb_bg_layout_light">
                                <div className="et_pb_text_inner"><h3>Basic Steps</h3>
                                  <h2>Process</h2></div>
                              </div>
                            </div>
                          </div>
                          <div className="et_pb_row ">


                            <div className="et_pb_column et_pb_column_1_3">
                              <span className="columnBoxHeading">Book Creator</span>

                              <div className="et_pb_with_border et_pb_module et_pb_image et_pb_image_3 et_hover_enabled">

                                <span className="et_pb_image_wrap has-box-shadow-overlay"><div className="box-shadow-overlay"></div>
                                  {/* <img decoding="async" width="1024" height="1024" src={textInjestion} alt="" title="Text Ingestion" srcSet="https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294396055-1024x1024.jpg 1024w, https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294396055-980x980.jpg 980w, https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294396055-480x480.jpg 480w" sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw" className="wp-image-183" /> */}
                                  <img
                                    decoding="async"
                                    width="1024"
                                    height="1024"
                                    src={textIngestionLarge}
                                    alt="Text Ingestion"
                                    title="Text Ingestion"
                                    srcSet={`${textIngestionLarge} 1024w, ${textIngestionMedium} 980w, ${textIngestionSmall} 480w`}
                                    sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw"
                                    className="wp-image-183"
                                  />
                                </span>
                              </div><div className="et_pb_module et_pb_text et_pb_text_8  et_pb_text_align_center et_pb_bg_layout_light">

                                <div className="et_pb_text_inner"><h3>Text Ingestion</h3>
                                  <p>Download book text</p></div>
                              </div>
                            </div>
                            <div className="et_pb_column et_pb_column_1_3">
                              <span className="columnBoxHeading">The Working Deal</span>

                              <div className="et_pb_with_border et_pb_module et_pb_image et_pb_image_2 et_hover_enabled">
                                <span className="et_pb_image_wrap has-box-shadow-overlay"><div className="box-shadow-overlay"></div>
                                  {/* <img decoding="async" width="1024" height="1024" src={robotReader} alt="" title="AI at work" srcSet="https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294257189-1024x1024.jpg 1024w, https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294257189-980x980.jpg 980w, https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294257189-480x480.jpg 480w" sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw" className="wp-image-172" /> */}
                                  <img
                                    decoding="async"
                                    width="1024"
                                    height="1024"
                                    src={bookCreatorVoiceActorDeal}
                                    alt="AI at work"
                                    title="AI at work"
                                    srcSet={`${bookCreatorVoiceActorDeal} 1024w, ${bookCreatorVoiceActorDeal} 980w, ${bookCreatorVoiceActorDeal} 480w`}
                                    sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw"
                                    className="wp-image-172"
                                  />
                                </span>
                              </div><div className="et_pb_module et_pb_text et_pb_text_7  et_pb_text_align_center et_pb_bg_layout_light">
                                <div className="et_pb_text_inner"><h3>Book Creator & Voice Actor</h3>
                                  <p>Agreement means new audio books</p></div>
                              </div>
                            </div>
                            <div className="et_pb_column et_pb_column_1_3">
                              <span className="columnBoxHeading">Voice Actor</span>

                              <div className="et_pb_with_border et_pb_module et_pb_image et_pb_image_1 et_hover_enabled">
                                <span className="et_pb_image_wrap has-box-shadow-overlay"><div className="box-shadow-overlay"></div>
                                  {/* <img decoding="async" width="808" height="824" src={narrator} alt="" title="Narrator One" srcSet="https://awethorator.com/wp-content/uploads/2023/04/narrator_1-1.png 808w, https://awethorator.com/wp-content/uploads/2023/04/narrator_1-1-480x490.png 480w" sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) 808px, 100vw" className="wp-image-81" /></span> */}
                                  <img
                                    decoding="async"
                                    width="808"
                                    height="824"
                                    src={voiceActorReading}
                                    alt="Narrator One"
                                    title="Narrator One"
                                    srcSet={`${voiceActorReading} 808w, ${voiceActorReading} 480w`}
                                    sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) 808px, 100vw"
                                    className="wp-image-81"
                                  />
                                </span>

                              </div><div className="et_pb_module et_pb_text et_pb_text_6  et_pb_text_align_center et_pb_bg_layout_light">
                                <div className="et_pb_text_inner"><h3>Provide Speech Sample</h3>
                                  <p>Record 15min of Audio</p></div>
                              </div>
                            </div>
                          </div>
                          <div className="et_pb_row ">
                            <div className="et_pb_column et_pb_column_1_3"></div>
                            <div className="et_pb_column et_pb_column_1_3">
                              <span className="columnBoxHeading">Automatics</span>
                              <div className="et_pb_with_border et_pb_module et_pb_image et_pb_image_2 et_hover_enabled">
                                <span className="et_pb_image_wrap has-box-shadow-overlay"><div className="box-shadow-overlay"></div>
                                  {/* <img decoding="async" width="1024" height="1024" src={robotReader} alt="" title="AI at work" srcSet="https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294257189-1024x1024.jpg 1024w, https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294257189-980x980.jpg 980w, https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294257189-480x480.jpg 480w" sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw" className="wp-image-172" /> */}
                                  <img
                                    decoding="async"
                                    width="1024"
                                    height="1024"
                                    src={robotReaderLarge}
                                    alt="AI at work"
                                    title="AI at work"
                                    srcSet={`${robotReaderLarge} 1024w, ${robotReaderMedium} 980w, ${robotReaderSmall} 480w`}
                                    sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw"
                                    className="wp-image-172"
                                  />
                                </span>
                              </div><div className="et_pb_module et_pb_text et_pb_text_7  et_pb_text_align_center et_pb_bg_layout_light">
                                <div className="et_pb_text_inner"><h3>Let AI Work</h3>
                                  <p>AI will create speech Model<br></br>and final audio</p></div>
                              </div>
                            </div>
                            <div className="et_pb_column et_pb_column_1_3"></div>


                          </div>
                          <div className="et_pb_row ">
                            <div className="et_pb_column et_pb_column_1_3 et_pb_column_empty">
                            </div><div className="et_pb_column et_pb_column_1_3">
                              <div className="et_pb_with_border et_pb_module et_pb_image et_pb_image_4 et_hover_enabled">
                                <span className="et_pb_image_wrap has-box-shadow-overlay"><div className="box-shadow-overlay"></div>
                                  {/* <img decoding="async" width="1024" height="1024" src={bookListener} alt="" title="Audio Book Listeners" srcSet="https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294374881-1024x1024.jpg 1024w, https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294374881-980x980.jpg 980w, https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294374881-480x480.jpg 480w" sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw" className="wp-image-176" /> */}
                                  <img
                                    decoding="async"
                                    width="1024"
                                    height="1024"
                                    src={bookListenerLarge}
                                    alt="Audio Book Listeners"
                                    title="Audio Book Listeners"
                                    srcSet={`${bookListenerLarge} 1024w, ${bookListenerMedium} 980w, ${bookListenerSmall} 480w`}
                                    sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw"
                                    className="wp-image-176"
                                  />

                                </span>
                              </div><div className="et_pb_module et_pb_text et_pb_text_9  et_pb_text_align_center et_pb_bg_layout_light">
                                <div className="et_pb_text_inner"><h3>Upload Finished Audio File</h3>
                                  <p>Import finished audio book</p></div>
                              </div>
                            </div><div className="et_pb_column et_pb_column_1_3 et_pb_column_empty">
                            </div>
                          </div>

                        </div><div className="et_pb_section et_pb_section_2 et_pb_with_background et_section_regular">
                          <div className="et_pb_row et_pb_row_7">
                            <div className="et_pb_column et_pb_column_4_4">
                              <div className="et_pb_module et_pb_text et_pb_text_10  et_pb_text_align_center et_pb_bg_layout_light">
                                <div className="et_pb_text_inner"><h3>Features Coming Up</h3>
                                  <h2>Upcoming Features</h2></div>
                              </div>
                            </div>

                          </div><div className="et_pb_row et_pb_row_8">
                            <div className="et_pb_column et_pb_column_3_5">

                              <div className="et_pb_module et_pb_image et_pb_image_5">

                                <span className="et_pb_image_wrap has-box-shadow-overlay"><div className="box-shadow-overlay"></div>
                                  {/* <img decoding="async" width="1024" height="1024" src={textInjestion} alt="" title="Media Pipeline" srcSet="https://awethorator.com/wp-content/uploads/2023/05/shutterstock_2294394255-1024x1024.png 1024w, https://awethorator.com/wp-content/uploads/2023/05/shutterstock_2294394255-980x980.png 980w, https://awethorator.com/wp-content/uploads/2023/05/shutterstock_2294394255-480x480.png 480w" sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw" className="wp-image-399" /> */}
                                  <img
                                    decoding="async"
                                    width="1024"
                                    height="1024"
                                    src={mediaIngestionLarge}
                                    alt="Media Pipeline"
                                    title="Media Pipeline"
                                    srcSet={`${mediaIngestionLarge} 1024w, ${mediaIngestionMedium} 980w, ${mediaIngestionSmall} 480w`}
                                    sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw"
                                    className="wp-image-399"
                                  />

                                </span>
                              </div>
                            </div><div className="et_pb_column et_pb_column_2_5">

                              <div className="et_pb_module et_pb_cta_0 et_pb_promo  et_pb_text_align_left et_pb_bg_layout_light">

                                <div className="et_pb_promo_description"><h3 className="et_pb_module_header">Social Media Helpers</h3>
                                  <div><p>The Architect<br />…recently, in a meeting</p>
                                    <p>We’ll give you a hand with Social Media creation. Maybe you can convert your text to audio using one of our proprietary Voice Artists…not soon, but sometime after that.</p>
                                  </div>
                                </div>
                                <div className="btn-12">Read More</div>
                              </div>
                            </div>

                          </div><div className="et_pb_row et_pb_row_9 et_pb_equal_columns et_pb_gutters1">
                            <div className="et_pb_column et_pb_column_2_5 et_pb_column_empty">


                            </div><div className="et_pb_column et_pb_column_3_5">

                              <div className="et_pb_module et_pb_image et_pb_image_6">

                                <span className="et_pb_image_wrap has-box-shadow-overlay"><div className="box-shadow-overlay"></div>
                                  {/* <img decoding="async" width="1024" height="1024" src={brightTree} alt="" title="Bright Idea" srcSet="https://awethorator.com/wp-content/uploads/2023/05/bright_idea_on_tree-1024x1024.png 1024w, https://awethorator.com/wp-content/uploads/2023/05/bright_idea_on_tree-980x980.png 980w, https://awethorator.com/wp-content/uploads/2023/05/bright_idea_on_tree-480x480.png 480w" sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw" className="wp-image-404" /> */}
                                  <img
                                    decoding="async"
                                    width="1024"
                                    height="1024"
                                    src={brightTreeLarge}
                                    alt="Bright Idea"
                                    title="Bright Idea"
                                    srcSet={`${brightTreeLarge} 1024w, ${brightTreeMedium} 980w, ${brightTreeSmall} 480w`}
                                    sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw"
                                    className="wp-image-399"
                                  />


                                </span>
                              </div><div className="et_pb_module et_pb_cta_1 et_pb_promo  et_pb_text_align_left et_pb_bg_layout_light">

                                <div className="et_pb_promo_description"><h3 className="et_pb_module_header">Presentation Assets</h3><div><p>The Presenter<br />…at a project planning</p>
                                  <p>Spice up your presentations with clever, innovative, entertaining and educational dynamics.</p></div></div>
                                <div className="btn-12">View Details</div>
                              </div>
                            </div>

                          </div><div className="et_pb_row et_pb_row_10">
                            <div className="et_pb_column et_pb_column_4_4">
                              <div className="et_pb_button_module_wrapper et_pb_button_1_wrapper et_pb_button_alignment_right et_pb_module ">
                                <div className="btn-13" style={{ border: "solid 1px #666666" }}>View our Thinking</div>
                              </div>
                            </div>
                          </div>
                        </div><div className="et_pb_section et_pb_section_3 et_pb_with_background et_section_regular">
                          <div className="et_pb_row et_pb_row_11">
                            <div className="et_pb_column et_pb_column_4_4">
                              <div className="et_pb_module et_pb_text et_pb_text_11  et_pb_text_align_center et_pb_bg_layout_dark">
                                <div className="et_pb_text_inner"><h3>Examples</h3>
                                  <h2>Example Stories</h2></div>
                              </div><div className="et_pb_module et_pb_text et_pb_text_12  et_pb_text_align_center et_pb_bg_layout_dark">
                                <div className="et_pb_text_inner"><p>Listen to a few examples (snippets) of genuine awethorator work.</p></div>
                              </div><div className="et_pb_button_module_wrapper et_pb_button_2_wrapper et_pb_button_alignment_center et_pb_module ">
                                <div className="btn-13">Examples</div>
                              </div>
                            </div>

                          </div>
                        </div><div className="et_pb_section et_pb_section_4 et_section_regular">
                          <div className="et_pb_row et_pb_row_12">
                            <div className="et_pb_column et_pb_column_1_2">

                              <div className="et_pb_module et_pb_text et_pb_text_13  et_pb_text_align_left et_pb_bg_layout_light">

                                <div className="et_pb_text_inner"><h3>Available Narrators</h3>
                                  <h2>Narrator Voices</h2>
                                  <p>Available pre-processed voices<br />
                                    No training required.</p></div>
                              </div><div className="et_pb_button_module_wrapper et_pb_button_3_wrapper et_pb_button_alignment_left et_pb_button_alignment_tablet_center et_pb_module ">
                                <div className="btn-13" style={{ border: "solid 1px #666666", marginTop: "20px", marginLeft: "5%" }}>Learn More</div>

                              </div>
                            </div><div className="et_pb_column et_pb_column_1_2">
                              <div className="et_pb_module et_pb_image et_pb_image_7">
                                <span className="et_pb_image_wrap ">
                                  {/* <img decoding="async" width="1024" height="1024" src={readerOnStack} alt="" title="Our Narrator Models" srcSet="https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294366549-1024x1024.png 1024w, https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294366549-980x980.png 980w, https://awethorator.com/wp-content/uploads/2023/04/shutterstock_2294366549-480x480.png 480w" sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw" className="wp-image-201" /> */}
                                  <img
                                    decoding="async"
                                    width="1024"
                                    height="1024"
                                    src={readerOnStackLarge}
                                    alt="Our Narrator Models"
                                    title="Our Narrator Models"
                                    srcSet={`${readerOnStackLarge} 1024w, ${readerOnStackMedium} 980w, ${readerOnStackSmall} 480w`}
                                    sizes="(min-width: 0px) and (max-width: 480px) 480px, (min-width: 481px) and (max-width: 980px) 980px, (min-width: 981px) 1024px, 100vw"
                                    className="wp-image-399"
                                  />


                                </span>
                              </div>
                            </div>

                          </div>
                        </div><div className="et_pb_section et_pb_section_5 et_pb_with_background et_section_regular">
                          <div className="et_pb_row et_pb_row_13">
                            <div className="et_pb_column et_pb_column_4_4">
                              <div className="et_pb_module et_pb_text et_pb_text_14  et_pb_text_align_center et_pb_bg_layout_light">
                                <div className="et_pb_text_inner"><h3>Article</h3>
                                  <h2>Latest News</h2></div>
                              </div>
                            </div>
                          </div>
                          <div className="et_pb_row et_pb_row_14">
                            <div className="et_pb_column et_pb_column_4_4">
                              <div className="et_pb_with_border et_pb_module et_pb_article_0 et_pb_article_grid_wrapper et_pb_bg_layout_light">
                                <div className="et_pb_article_grid clearfix ">
                                  <div className="et_pb_ajax_pagination_container">
                                    <div className="et_pb_salvattore_content" data-columns="3">
                                      {displayNewsItems()}
                                    </div>
                                  </div>
                                </div>
                              </div><div className="et_pb_button_module_wrapper et_pb_button_4_wrapper et_pb_button_alignment_center et_pb_module ">
                                <div className="btn-13" style={{ border: "solid 1px #666666", marginTop: "20px", marginLeft: "5%" }}>Read More</div>
                              </div>
                            </div>

                          </div>
                        </div>
                        <div className="et_pb_section et_pb_section_6 et_section_regular">
                          <div className="et_pb_with_border et_pb_row et_pb_row_15 et_pb_gutters2 et_pb_row_4col">
                            <div className="et_pb_column et_pb_column_1_4 et_pb_column_24">
                              <div className="et_pb_module et_pb_text et_pb_text_15  et_pb_text_align_left et_pb_bg_layout_light">
                                <div className="et_pb_text_inner">
                                  <h3>Address</h3>
                                  <p>P.O. Box 9823<br />
                                    Santa Cruz, CA 95066, USA<br />
                                    info.awethorator.com</p>
                                </div>
                              </div>
                            </div>
                            <div className="et_pb_column et_pb_column_1_4">
                              <div className="et_pb_module et_pb_text et_pb_text_16  et_pb_text_align_left et_pb_bg_layout_light">
                                <div className="et_pb_text_inner center"><h3>Follow</h3></div>
                              </div>
                              <div className="et_pb_text_inner center">
                                <Link to="/" > <Icon className="footerSocialLinks" name="facebook f" size="big" color="grey" /></Link>
                                <Link to="/" > <Icon className="footerSocialLinks" name="twitter" size="big" color="grey" /></Link>
                                <Link to="/" > <Icon className="footerSocialLinks" name="instagram" size="big" color="grey" /></Link>
                              </div>
                            </div>
                            <div className="et_pb_column et_pb_column_1_4">
                              <div className="et_pb_module et_pb_text et_pb_text_17  et_pb_text_align_left et_pb_bg_layout_light">
                                <div className="et_pb_text_inner"><h3>Subscribe</h3></div>
                              </div>
                              <div className="et_pb_module et_pb_signup_0 
                                et_pb_newsletter_layout_left_right
                                et_pb_newsletter et_pb_subscribe clearfix
                                et_pb_text_align_left et_pb_bg_layout_light
                                et_pb_no_bg et_pb_newsletter_description_no_title
                                et_pb_newsletter_description_no_content">

                                <div className="et_pb_newsletter_description et_multi_view_hidden"></div>

                                <div className="et_pb_newsletter_form">
                                  <form method="post" data-form-type="other">
                                    <div className="et_pb_newsletter_result et_pb_newsletter_error"></div>
                                    <div className="et_pb_newsletter_result et_pb_newsletter_success">
                                      <h2>Success!</h2>
                                    </div>
                                    <div className="et_pb_newsletter_fields">
                                      <p className="et_pb_newsletter_field et_pb_contact_field_last et_pb_contact_field_last_tablet et_pb_contact_field_last_phone">
                                        <label className="et_pb_contact_form_label" htmlFor="et_pb_signup_email" style={{ display: "none" }}>Email</label>
                                        <input id="et_pb_signup_email" className="input" type="text" placeholder="Email" name="et_pb_signup_email" data-kwimpalastatus="alive" data-kwimpalaid="1688570949101-0" fdprocessedid="ss2e39" data-form-type="email" />
                                      </p>
                                      <div className="btn-13" style={{ border: "solid 1px #666666" }}>Subscribe</div>
                                    </div>
                                    <input type="hidden" value="mailchimp" name="et_pb_signup_provider" />
                                    <input type="hidden" value="11a914d1cc" name="et_pb_signup_list_id" />
                                    <input type="hidden" value="SlavaET" name="et_pb_signup_account_name" />
                                    <input type="hidden" value="true" name="et_pb_signup_ip_address" />
                                    <input type="hidden" value="9bc6c3c81105725e1d9e486d57b91501" name="et_pb_signup_checksum" />
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </article>
              </div>
            </div>
          </div>
        </div >

        {AuthStdFooter()}
      </>
    )
  }
  return (<>{landingPage()}</>)
}

